import React from 'react';

import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';

import { ReactComponent as PlusCircle } from 'assets/icons/close-icon.svg';
import { ReactComponent as PlayCircle } from 'assets/icons/play-circle.svg';
import { ReactComponent as StopCircle } from 'assets/icons/stop-circle.svg';

import { ReactComponent as InfoIcon } from '../../../../assets/icons/info.svg';
import RenderWithRole from '../../../../hoc/renderWithRole';

import './LessonsItem.scss';

const LessonsItem: React.FC<{ listOfClasses: any; main_class: string; finishClass: any }> = ({
  finishClass,
  listOfClasses,
  main_class,
}) => {
  const { t } = useTranslation('live_classes');
  let key = 0;
  const { i18n } = useTranslation();

  return (
    <>
      {listOfClasses.map(obj => {
        return (
          <div className={`lessons-list ${main_class}`} key={key++}>
            <h5 className={'title'}>
              {obj.name}
              <div className="info-icon">
                <InfoIcon
                  style={{
                    width: 16,
                    height: 16,
                    marginLeft: 5,
                    stroke: '#176BFB',
                    opacity: 0.5,
                  }}
                />
                <div className="drop-down ">
                  <p>
                    {t('Invited')}: {obj.students_at_classes_aggregate?.aggregate?.count}
                  </p>
                  <p>
                    {t('Attending')}: 0 / {obj.students_at_classes_aggregate?.aggregate?.count}
                  </p>
                  {/* TODO: Problem with query, needs heavy reconstruction for this */}
                  {/* <p> */}
                  {/*    {t('Teacher')}: */}
                  {/* </p> */}
                  <p className={'description'}>{obj.description}</p>
                </div>
              </div>
            </h5>
            <div className={'status'}>
              <p
                className={` 
                ${DateTime.fromISO(obj.starting_at) > DateTime.now() ? 'green' : 'non-green'}`}
              >
                {/* {DateTime.fromISO(obj.starting_at) < DateTime.now() ? "In Progress" : 'Scheduled'} */}

                {obj.status[i18n.language]}
              </p>
            </div>
            <div className={'date-info'}>
              <small>
                <PlayCircle /> {t('Start')}{' '}
                {DateTime.fromISO(obj.starting_at).toLocaleString(DateTime.DATE_SHORT)}{' '}
                {DateTime.fromISO(obj.starting_at).toLocaleString(DateTime.TIME_24_SIMPLE)}
              </small>
              <small>
                <StopCircle /> {t('End')}{' '}
                {DateTime.fromISO(obj.starting_at)
                  .plus({ minutes: obj.duration })
                  .toLocaleString(DateTime.DATE_SHORT)}{' '}
                {DateTime.fromISO(obj.starting_at)
                  .plus({ minutes: obj.duration })
                  .toLocaleString(DateTime.TIME_24_SIMPLE)}
              </small>
            </div>
            <div className="button">
              {main_class === 'danger' && <a href="#"> {t('Finished')}</a>}
              {main_class === 'warning' && <a href={`/live/${obj.id}`}> {t('Attend class')}</a>}
              {main_class === 'upcoming' && <a href="#"> {t('Upcoming')}</a>}
            </div>
            {RenderWithRole({
              teacher: (
                <PlusCircle
                  onClick={() => {
                    finishClass(obj.id);
                  }}
                  className="close"
                />
              ),
            })}
          </div>
        );
      })}
    </>
  );
};

export default LessonsItem;
